import {
    ROUTES_SETTINGS_ACCOUNT,
    ROUTES_SETTINGS_INTEGRATIONS,
    ROUTES_SETTINGS_INTEGRATIONS_GARMIN_PUSH,
    ROUTES_SETTINGS_INTEGRATIONS_POLAR,
    ROUTES_SETTINGS_INTEGRATIONS_STRAVA,
    ROUTES_SETTINGS_INTEGRATIONS_SUUNTO,
    ROUTES_SETTINGS_MY_CLUBS,
    ROUTES_SETTINGS_PRIVACY_SETTINGS
} from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

export default {
    path: '/settings',
    name: 'settings',
    component: () => import(/*webpackChunkName: 'settings'*/ '@/views/Settings.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/settings/account',
            name: ROUTES_SETTINGS_ACCOUNT,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/account-details/Account.vue')
        },
        {
            path: '/settings/integrations',
            name: ROUTES_SETTINGS_INTEGRATIONS,
            beforeEnter: guardRouteIntegrations,
            component: () =>
                import(
                    /*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/Integrations.vue'
                )
        },
        {
            path: '/settings/integrations/garmin-push/connect',
            name: ROUTES_SETTINGS_INTEGRATIONS_GARMIN_PUSH,
            component: () =>
                import(
                    /*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsGarminPush.vue'
                )
        },
        {
            path: '/settings/integrations/strava/connect',
            name: ROUTES_SETTINGS_INTEGRATIONS_STRAVA,
            component: () =>
                import(
                    /*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsStrava.vue'
                )
        },
        {
            path: '/connect-polar-profile',
            name: ROUTES_SETTINGS_INTEGRATIONS_POLAR,
            component: () =>
                import(
                    /*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsPolar.vue'
                )
        },
        {
            path: '/connect-suunto-profile',
            name: ROUTES_SETTINGS_INTEGRATIONS_SUUNTO,
            component: () =>
                import(
                    /*webpackChunkName: 'settings-integrations'*/ '@/components/settings/integrations/IntegrationsSuunto.vue'
                )
        },
        {
            path: '/settings/my-clubs',
            name: ROUTES_SETTINGS_MY_CLUBS,
            component: () => import(/*webpackChunkName: 'settings'*/ '@/components/settings/my-clubs/ClubsList.vue')
        },
        {
            path: '/settings/privacy-settings',
            name: ROUTES_SETTINGS_PRIVACY_SETTINGS,
            beforeEnter: guardRoutePrivacySettings,
            component: () =>
                import(/*webpackChunkName: 'settings'*/ '@/components/settings/privacy-settings/PrivacySettings.vue')
        }
    ]
};

function guardRoutePrivacySettings(to, from, next) {
    const unauthorized = store.getters.isSelectedClubIndividual || !store.getters.isCurrentUserAthleteOfSelectedClub;
    guardRoute(next, unauthorized);
}

function guardRouteIntegrations(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureImports'];
    guardRoute(next, false, notInFeatureSet);
}
